import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/Seo/index';
import ContactUs from '../../components/ContactUs/ContactUs';



//const description= "The ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto.";

const ContactUsPage = props => {
    return (

        <Layout>
            <SEO title="Contact us" keywords={[`gatsby`, `application`, `react`]} />
            <ContactUs {...props}/>
        </Layout>

    );
};

export default ContactUsPage;